import { Component, computed, ElementRef, viewChild, ChangeDetectionStrategy } from '@angular/core'
import { CopyButtonComponent } from '../../buttons/copy-button/copy-button.component'

@Component({
  selector: 'lib-copy-span',
  imports: [CopyButtonComponent],
  templateUrl: './copy-span.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './copy-span.component.scss',
})
export class CopySpanComponent {
  readonly content = viewChild<ElementRef>('content')
  readonly textContent = computed(() => this.content()?.nativeElement.textContent?.trim())
}
